<h2 mat-dialog-title>Assurabilité</h2>
<mat-dialog-content>
<div class="panel panel-default">
    <div>
        <mat-form-field class="">
            <mat-label>CT1</mat-label>
            <input type="text" [ngModel]="insurability.ct1" name="ct1" matInput placeholder="CT1">
            <mat-hint class="hint-alert" *ngIf="insurability.ct1 != ct1">{{ ct1 }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="">
            <mat-label>CT2</mat-label>
            <input type="text" [ngModel]="insurability.ct2" name="ct2" matInput placeholder="CT2">
            <mat-hint class="hint-alert" *ngIf="insurability.ct2 != ct2">{{ ct2 }}</mat-hint>
        </mat-form-field>
    </div>
    <app-insurance-selection [insurance]="insurance"></app-insurance-selection>
    <div class="hint-alert" *ngIf="patient.patient.insurance.code !== insurability.mutuality">{{ patient.patient.insurance.code }}</div>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Fermer</button>
    <button mat-button (click)="updatePatient()">Mettre à jour</button>
</mat-dialog-actions>